import { useEffect } from 'react';

import { applyTheme, getStoredThemePreference, useSettingsStore } from '@tankef/core-react';

/**
 * Applies the visible theme before protected-route initialization runs.
 * This keeps auth/guest screens aligned with the user's local preference.
 */
export function ThemeBootstrap() {
  const theme = useSettingsStore(state => state.display.theme);
  const setTheme = useSettingsStore(state => state.setTheme);

  useEffect(() => {
    const visibleTheme = getStoredThemePreference() ?? theme;

    applyTheme(visibleTheme);

    if (theme !== visibleTheme) {
      setTheme(visibleTheme);
    }

    if (visibleTheme !== 'system') {
      return;
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleThemeChange = () => {
      applyTheme('system');
    };

    mediaQuery.addEventListener('change', handleThemeChange);

    return () => {
      mediaQuery.removeEventListener('change', handleThemeChange);
    };
  }, [setTheme, theme]);

  return null;
}
